'use strict';

var UTILS = UTILS || {};

UTILS.formBuilder = {
    _formBuild: function(form) {
        var selfForm = $('#' + form),
            fields = $(selfForm).find('.js-form-builder-item');

        fields.each(function() {
            var singleField = this,
                dependFields = $(singleField).data('form-depend-field'),
                dependConditions = $(singleField).data('form-depend-condition'),
                dependValues = $(singleField).data('form-depend-value');

            if (dependFields.length) {
                UTILS.formBuilder._checkDependencies(singleField);
            }
        });
    },

    _checkDependencies: function(field) {
        var dependFields = $(field).data('form-depend-field'),
            dependConditions = $(field).data('form-depend-condition'),
            dependValues = $(field).data('form-depend-value'),
            currentFormId = $(field).data('form-id').replace('form_builder',''),
            isOkToShow = false,
            countMatches = 0,
            typeArray = ['checkbox', 'radio'],
            allFields;

        $(dependFields).each(function(index) {
            var fieldId = dependFields[index] + currentFormId,
                fieldValue,
                fieldType,
                isChecked = false;

            fieldType = undefined || $('#' + fieldId).attr('type');

            // check if there is field with id, if not = group of radiobuttons
            if ( !document.querySelector('#' + fieldId) ) {
                fieldType = 'radio';
            }

            // if field type not checkbox or input
            if ( typeArray.indexOf(fieldType) === -1 ) {
                fieldValue = $('#' + fieldId).val().toString();

                if ( dependConditions[index].toString() === 'equal' ) {
                    if ( fieldValue === dependValues[index].toString()) {
                        countMatches++;
                    }
                } else {
                    if ( fieldValue !==  dependValues[index].toString()) {
                        countMatches++;
                    }
                }
            // if field type checkbox
            } else if ( fieldType === 'checkbox') {
                fieldValue = $('#' + fieldId).val().toString();

                if ( dependConditions[index].toString() === 'equal' ) {
                    if ( fieldValue === "Ticked" && $('#' + fieldId).is(':checked') ) {
                        countMatches++;
                    }
                } else {
                    if ( fieldValue ===  "Ticked" && !($('#' + fieldId).is(':checked')) ) {
                        countMatches++;
                    }
                }
            // if field type radio (get group by name)
            } else {
                var checkedRadioGroup = document.querySelectorAll('input[name="' + fieldId + '"]:checked');
                [].forEach.call(checkedRadioGroup, function(radioItem) {

                    if ( dependConditions[index].toString() === 'equal' ) {
                        if ( radioItem.value.toString() === dependValues[index].toString()) {
                            countMatches++;
                        }
                    } else {
                        if ( radioItem.value.toString() !==  dependValues[index].toString()) {
                            countMatches++;
                        }
                    }
                });
            }
        });

        if (dependFields.length === countMatches) {
            $(field).parent().removeClass('hidden');

            allFields = field.parentNode.querySelectorAll('.js-form-builder-field');
            [].forEach.call(allFields, function(fieldItem) {
                $(fieldItem).removeAttr('disabled');
            });

        } else {
            $(field).parent().addClass('hidden');

            allFields = field.parentNode.querySelectorAll('.js-form-builder-field');
            [].forEach.call(allFields, function(fieldItem) {
                $(fieldItem).attr('disabled', 'disabled');
            });
        }
    },

    fieldBlur: function() {
        $('input.js-form-builder-field, textarea.js-form-builder-field').on('input', function() {
            UTILS.formBuilder._formBuild($(this).data('form-id'));
        });

        $('select.js-form-builder-field, input[type="checkbox"].js-form-builder-field, input[type="radio"].js-form-builder-field').change( function() {
            UTILS.formBuilder._formBuild($(this).data('form-id'));
        });
    },

    checkAfterPageIsLoaded: function() {
        if ( $('.js-form-builder') ) {
            var allForms = $('.js-form-builder');

            allForms.each(function(index) {
                UTILS.formBuilder._formBuild( $(this).attr('id') );
            });
        }
    },

    init: function() {
        this.fieldBlur();
        this.checkAfterPageIsLoaded();
    }
};